export default {
      id: "sensors__humidity-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#sensors__humidity",
      toString: function () {
        return this.url;
      }
    }